<template>
  <layout>
    <div slot="content">
      <i-card title="景区门票">
        <div slot="content">
          <el-table
            v-loading="loading"
            :border="true"
            :highlight-current-row="true"
            :data="scenicList"
            style="width: 100%">
            <el-table-column
              prop="id"
              label="产品ID"
              width="80"
            >
            </el-table-column>
            <el-table-column
              prop="cover_pic"
              label="封面图片"
              width="110"
            >
              <el-image  slot-scope="scope" lazy style="width: 80px; height: 80px;border:1px solid #eee;border-radius: 10px" :preview-src-list="[scope.row.cover_pic]" :src="scope.row.cover_pic" fit="cover"/>
            </el-table-column>
            <el-table-column
              prop="title"
              label="套餐名称"
              min-width="200"
            >
            </el-table-column>
            <el-table-column
              prop="sale_count"
              label="销量"
              width="100"
            >
            </el-table-column>
            <el-table-column
              label="销售状态"
              width="100"
            >
              <template slot-scope="scope">
                <el-tag size="mini" type="success" v-if="scope.row.on_sale === 1">销售中</el-tag>
                <el-tag size="mini" type="danger" v-else>已下架</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="created_at"
              label="创建时间"
              width="160"
            >
            </el-table-column>
            <el-table-column
              label="操作"
              width="450"
              fixed="right"
            >
              <div style="text-align: center" slot-scope="scope">
                <router-link :to="{name:'product.edit_scenic',query:{product_id:scope.row.id}}">
                  <el-button size="mini" type="primary">编辑</el-button>
                </router-link>
                <el-button size="mini" type="primary"
                           @click="setDistribution(scope.row.id)">
                  分销
                </el-button>

                <el-button size="mini" type="primary" style="margin-top: 0"
                           @click="setExtension(scope.row.id,scope.row.title)">扩展设置
                </el-button>
                <el-button size="mini" type="primary" style="margin-top: 0"
                           :disabled="scope.row.on_sale!=1"
                           @click="setStock(scope.row.id,scope.row.title)">库存设置
                </el-button>

              </div>
            </el-table-column>
          </el-table>
        </div>
        <div slot="right-menu">
          <router-link :to="{name:'product.add_scenic'}">
            <el-button type="success" size="medium" icon="el-icon-plus">新建景区门票</el-button>
          </router-link>
        </div>
      </i-card>
      <i-fx :show="showFxStatus" :product-id="currProductId" @change="showFx"/>
      <i-extension :show="showExtensionStatus" :product-id="currProductId" :goods-title="currGoodsTitle" @change="showExtension"/>
      <i-stock :show="showStockStatus" :product-id="currProductId" :goods-title="currGoodsTitle" @change="setShowStock"/>
    </div>
  </layout>
</template>

<script>
import iFx from "@/components/i-fenxiao";
import iExtension from "@/components/i-extension"
import iPft from "@/components/i-pft"
import iStock from "@/components/i-stock"


export default {
  name: "scenic",
  components: {
    iExtension,
    iFx,
    iPft,
    iStock,
  },
  data() {
    return {
      scenicList: [],
      loading: false,
      showFxStatus: false,
      currUnicode: '',
      currProductId: '',
      showExtensionStatus: false,
      showPft: false,
      currGoodsTitle: '',
      showStockStatus: false
    }
  },
  methods: {
    getList: function () {
      let _self = this;
      this.loading = true;
      this.$http.request('productList', {type: 12}).then((res) => {
        _self.scenicList = res.data;
        _self.loading = false;
      });
    },
    setDistribution: function (productId) {
      this.showFxStatus = true;
      this.currProductId = productId;
    },
    showPftDialog: function (productId, title) {
      this.showPft = true;
      this.currProductId = productId;
      this.currGoodsTitle = title;
    },
    setShowPft: function (show) {
      this.showPft = show;
    },
    showFx: function (show) {
      this.showFxStatus = show;
    },
    showExtension: function (show) {
      this.showExtensionStatus = show;
    },
    setExtension: function (productId, title) {
      this.showExtensionStatus = true;
      this.currProductId = productId;
      this.currGoodsTitle = title;
    },
    setStock: function (productId, title) {
      this.showStockStatus = true;
      this.currProductId = productId;
      this.currGoodsTitle = title;
    },
    setShowStock: function (show) {
      this.showStockStatus = show;
    },
    delProduct: function (id) {
      this.$confirm('是否删除该商品？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.request('delProduct', {product_id: id}).then((res) => {
          let _self = this;
          if (res.status === 'success') {
            this.$message({
              type: 'success',
              message: res.message,
              onClose: function () {
                _self.getList();
              }
            });
          }
        });
      })
    }
  },
  created: function () {
    this.getList();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/product/scenic.vue